export default __webpack_public_path__ + "assets/Picture14.png";